(() => {
  const main = document.querySelector('.paper-image-zoom img');
  const dialog = document.querySelector('.paper-lightbox');
  document.querySelectorAll('[data-paper-image]').forEach(button => button.addEventListener('click', () => {
    main.style.transform = button.hasAttribute('data-paper-detail') ? 'scale(2)' : '';
    main.src = button.dataset.paperImage;
    main.removeAttribute('srcset');
    main.alt = button.dataset.paperAlt;
    main.closest('button').setAttribute('aria-label', 'Enlarge ' + main.alt);
    document.querySelectorAll('[data-paper-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  document.querySelector('[data-paper-zoom]')?.addEventListener('click', () => {
    const selected = document.querySelector('[data-paper-image][aria-pressed="true"]');
    dialog.querySelector('img').src = selected?.dataset.paperImage || dialog.querySelector('img').dataset.fullImage;
    dialog.querySelector('img').alt = main.alt;
    dialog.showModal();
  });
  document.querySelector('[data-paper-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
})();
